export interface Testimonial {
  quote: string
  author: string
  context: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend every Sunday night searching for activities and putting together the next week’s art classes. Having everything organized by topic, technique, and level completely changes the way I prepare. I actually have weekends now.',
    author: 'Art Teacher',
    context: 'Elementary Art Educator',
  },
  {
    quote:
      'The visual references are what I use the most. Instead of spending time searching online for examples, I can open the material, show the technique, and move directly into the activity. It cuts my class setup time in half.',
    author: 'Visual Arts Teacher',
    context: 'Secondary School',
  },
  {
    quote:
      'I teach students at different levels, so having beginner, intermediate, and advanced possibilities inside the same system makes planning much easier. I’m not creating three separate lessons anymore.',
    author: 'Art Instructor',
    context: 'Mixed-Level Classes',
  },
  {
    quote:
      'The Material Swap Guide was a game-changer for me. My school has zero budget, and I thought I couldn’t use this system. Now I can teach the same quality lessons with what I already have. It’s a relief.',
    author: 'Art Educator',
    context: 'Under-Resourced School',
  },
  {
    quote:
      'The 365 prompts eliminate the daily “what do we do to warm up” question. I just project the day’s prompt and we’re moving in 30 seconds. My students love having that consistency.',
    author: 'High School Art Teacher',
    context: 'Secondary Educator',
  },
  {
    quote:
      'This system gives me confidence I didn’t have before. I’m not improvising. I’m teaching a professional, organized curriculum. My students can see that, and it changes how they take the class seriously.',
    author: 'Certified Art Teacher',
    context: 'New Teacher to the Field',
  },
]
